__webpack_require__.p = "/Myportfolio-june/";